import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {catchError,  map, switchMap, withLatestFrom} from 'rxjs/operators';
import {error, success} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import * as fromShared from '../../shared/reducers';
import {of} from 'rxjs';
import {SendBackResult} from '../../shared';
import {L10nTranslationService} from 'angular-l10n';
import {
  returnPlayerActionTypes,
  ReturnPlayerUpdateStatusAction,
  ReturnPlayerUpdateStatusFailAction,
  ReturnPlayerUpdateStatusSuccessAction
} from '../actions/anomaly-player-return';
import {ReturnPlayerService} from '../services/return-player.service';
import {LoadSubAnomalyListAction, LoadSubByClientListAction, LoadSubByClientListSimpleAction} from '../actions/subscription-list';

@Injectable()
export class ReturnPlayersEffect extends BaseEffect {


  update$ = createEffect(() => { return this.actions$.pipe(
    ofType(returnPlayerActionTypes.UPDATE_STATUS),
    debug('update contract link action received.'),
    map((action: ReturnPlayerUpdateStatusAction) => action.payload),
    switchMap((payload) =>
      this.returnPlayerService.update(payload , payload.subscriptions[0].clientUuid).pipe(
        switchMap((res: SendBackResult<boolean>) => of(new ReturnPlayerUpdateStatusSuccessAction() ,
          new LoadSubAnomalyListAction() , new LoadSubByClientListSimpleAction())),
        catchError(res => this.catchResponseError(res)))))
  });

  updateSuccess$ = createEffect(() => { return this.actions$.pipe(
    ofType(returnPlayerActionTypes.UPDATE_STATUS_SUCCESS),
    debug('update success contract link action received.'),
    withLatestFrom(this.store.pipe(select(fromShared.selectors.getCurrentClient))),
    switchMap(([data, client]) => [
      success(this.translation.translate('CLOSE_PLAYER_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))
    ]),
  )});


  updateFail$ = createEffect(() => { return this.actions$.pipe(ofType(returnPlayerActionTypes.UPDATE_STATUS_FAIL),
    debug('A server error occurred while update contract.'),
    map((err: ReturnPlayerUpdateStatusFailAction) =>
      error(this.translation.translate('CLOSE_PLAYER_ERROR') + ' ' + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private returnPlayerService: ReturnPlayerService,
              private store: Store<fromShared.AppState>,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new ReturnPlayerUpdateStatusFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    this.store.dispatch(new LoadSubByClientListAction());
    return new ReturnPlayerUpdateStatusFailAction(response['error'].message);
  }
}
